var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": _vm.closable ? 800 : undefined } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.cardTitle) + " "),
          _c("w-spacer"),
          _c("span", { staticClass: "last-update" }),
          _vm.closable
            ? _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _vm.archives.length > 0
            ? _c(
                "w-list",
                { class: { "archive-list-scroll": _vm.closable } },
                _vm._l(_vm.archives, function (archive) {
                  return _c("w-list-item", { key: archive.ID }, [
                    _c(
                      "div",
                      { staticClass: "line" },
                      [
                        _c("w-list-item-text", [
                          _c("span", { staticClass: "period" }, [
                            _vm._v(
                              _vm._s(_vm.$ct("ubl-archive.period")) +
                                " " +
                                _vm._s(
                                  _vm._f("printLocalDate")(archive.MinDate)
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("printLocalDate")(archive.MaxDate)
                                )
                            ),
                          ]),
                          _c("span", { staticClass: "footer" }, [
                            _c("span", { staticClass: "count" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$ct("ubl-archive.items", {
                                    count: archive.DocumentCount,
                                  })
                                )
                              ),
                            ]),
                            _c(
                              "span",
                              { staticClass: "time" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$ct("ubl-archive.created")) + " "
                                ),
                                _c("app-timeago", {
                                  attrs: { datetime: archive.TimeCreated },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.send"),
                                    expression: "$ct('common.send')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.sendUblArchive(archive.ID)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "envelope" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("common.download"),
                                    expression: "$ct('common.download')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadUblArchive(archive)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "download" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("create-public-url"),
                                    expression: "$ct('create-public-url')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.copyUblArchiveLink(archive)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "link" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    archive.Message
                      ? _c("span", { staticClass: "info" }, [
                          _vm._v(_vm._s(archive.Message)),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "status" },
                      [
                        !archive.isTracked
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct(
                                      "archive-status-unknown-tooltip"
                                    ),
                                    expression:
                                      "$ct('archive-status-unknown-tooltip')",
                                  },
                                ],
                                staticClass: "pill unknown",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "pill-icon" },
                                  [_c("w-fa", { attrs: { icon: "question" } })],
                                  1
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$ct("archive-status-unknown")) +
                                    " "
                                ),
                              ]
                            )
                          : [
                              archive.SentAt
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.sentTooltip(archive),
                                          expression: "sentTooltip(archive)",
                                        },
                                      ],
                                      staticClass: "pill done",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "pill-icon" },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "envelope" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ct("archive-sent-at", {
                                              date: _vm.shortDate(
                                                archive.SentAt
                                              ),
                                            })
                                          ) +
                                          " "
                                      ),
                                      archive.SentTo
                                        ? _c(
                                            "span",
                                            { staticClass: "pill-detail" },
                                            [_vm._v(_vm._s(archive.SentTo))]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _c("span", { staticClass: "pill pending" }, [
                                    _c(
                                      "span",
                                      { staticClass: "pill-icon" },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "envelope" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$ct("archive-not-sent")) +
                                        " "
                                    ),
                                  ]),
                              archive.AccountantDownloadedAt
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.printLocalDateTime(
                                            archive.AccountantDownloadedAt
                                          ),
                                          expression:
                                            "printLocalDateTime(archive.AccountantDownloadedAt)",
                                        },
                                      ],
                                      staticClass: "pill done",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "pill-icon" },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "user-check" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ct(
                                              "archive-accountant-downloaded-at",
                                              {
                                                date: _vm.shortDate(
                                                  archive.AccountantDownloadedAt
                                                ),
                                              }
                                            )
                                          ) +
                                          " "
                                      ),
                                      (archive.AccountantDownloadCount || 0) > 1
                                        ? _c(
                                            "span",
                                            { staticClass: "pill-count" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  archive.AccountantDownloadCount
                                                ) + "×"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _c("span", { staticClass: "pill pending" }, [
                                    _c(
                                      "span",
                                      { staticClass: "pill-icon" },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "user-check" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$ct(
                                            "archive-accountant-not-downloaded"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                              archive.LastDownloadedAt
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.printLocalDateTime(
                                            archive.LastDownloadedAt
                                          ),
                                          expression:
                                            "printLocalDateTime(archive.LastDownloadedAt)",
                                        },
                                      ],
                                      staticClass: "pill neutral",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "pill-icon" },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "download" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ct("archive-downloaded-at", {
                                              date: _vm.shortDate(
                                                archive.LastDownloadedAt
                                              ),
                                            })
                                          ) +
                                          " "
                                      ),
                                      (archive.DownloadCount || 0) > 1
                                        ? _c(
                                            "span",
                                            { staticClass: "pill-count" },
                                            [
                                              _vm._v(
                                                _vm._s(archive.DownloadCount) +
                                                  "×"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                      ],
                      2
                    ),
                  ])
                }),
                1
              )
            : _c(
                "w-list",
                [
                  _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("ubl-archive.none-found")) + " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-dropdown",
            {
              attrs: {
                up: "",
                disabled: !_vm.hasBookkeeping,
                items: _vm.dropdownItems,
                right: "",
              },
              on: {
                click: function ($event) {
                  return $event()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("ubl-archive.send-new")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.createArchiveModal,
            callback: function ($$v) {
              _vm.createArchiveModal = $$v
            },
            expression: "createArchiveModal",
          },
        },
        [
          _vm.createArchiveModal
            ? _c("app-create-ubl-archive-modal", {
                attrs: { "is-purchase": _vm.createPurchaseArchive },
                on: {
                  close: function ($event) {
                    _vm.createArchiveModal = false
                  },
                  done: function ($event) {
                    return _vm.getArchives()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.sendArchiveModal,
            callback: function ($$v) {
              _vm.sendArchiveModal = $$v
            },
            expression: "sendArchiveModal",
          },
        },
        [
          _vm.sendArchiveModal
            ? _c("app-create-ubl-archive-modal-created", {
                attrs: { "created-archive": _vm.toSendArchive },
                on: {
                  sent: function ($event) {
                    return _vm.getArchives()
                  },
                  close: function ($event) {
                    _vm.sendArchiveModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }